import { combineReducers } from "redux";
import {initialReducer} from './initialReducer.js'
import {authReducer} from "./authReducer"

const rootReducer = combineReducers({initialReducer,authReducer});
export default rootReducer;


